import React from 'react';
import { formatDate } from '../compartidos/utils';
import * as materialesService from '../../servicios/materialesService';

function TabProgreso({
  tasks,
  materiales,
  completedTasks,
  completedMateriales,
  setCompletedMateriales,
  restoreCompletedTask,
  deleteCompletedTask,
  restoreCompletedMaterial
}) {
  const handleDeleteCompletedMaterial = async (materialId) => {
    try {
      await materialesService.eliminarMaterialCompletado(materialId);
      setCompletedMateriales((prev) => prev.filter((m) => m.id !== materialId));
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCompletedMateriales((prev) => prev.filter((m) => m.id !== materialId));
      } else {
        console.error('Error al eliminar material completado:', error);
        alert('Error al eliminar el material completado.');
      }
    }
  };

  return (
    <div className="tab-content">
      <section className="progress-section-v2">
        {/* Header Subcontratos */}
        <div className="progress-header-bar">
          <span className="progress-badge" style={{ background: '#111827' }}>PROGRESO</span>
          <span className="progress-header-date">{new Date().toLocaleDateString('es-CL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
        </div>

        {/* Stats cards Subcontratos */}
        <div className="progress-cards-row" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
          <div className="progress-stat-card">
            <div className="progress-stat-icon" style={{ background: '#f9fafb', color: '#374151' }}>■</div>
            <div className="progress-stat-info">
              <span className="progress-stat-label">Total Subcontratos Activos</span>
              <span className="progress-stat-number">{tasks.length}</span>
            </div>
          </div>
          <div className="progress-stat-card">
            <div className="progress-stat-icon" style={{ background: '#f0fdf4', color: '#16a34a' }}>✓</div>
            <div className="progress-stat-info">
              <span className="progress-stat-label">Subcontratos Completados</span>
              <span className="progress-stat-number" style={{ color: '#16a34a' }}>{completedTasks.length}</span>
            </div>
          </div>
        </div>

        {/* Tabla Subcontratos Completados */}
        <div className="progress-table-section">
          <div className="critical-title-row">
            <span className="critical-square" style={{ color: '#374151' }}>■</span>
            <span className="critical-title-text">Subcontratos Completados</span>
            <span className="critical-count-badge" style={{ background: '#f9fafb', color: '#374151' }}>{completedTasks.length}</span>
          </div>

          <div className="table-wrapper">
            <table className="critical-table-email">
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>#</th>
                  <th>Espec.</th>
                  <th>Subcontrato</th>
                  <th style={{ textAlign: 'center' }}>Fecha Entrega</th>
                  <th style={{ textAlign: 'center' }}>Fecha Completada</th>
                  <th style={{ textAlign: 'center' }}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {completedTasks.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: '#999' }}>No hay subcontratos completados</td>
                  </tr>
                ) : (
                  completedTasks.map((task, index) => (
                    <tr key={task.id} className={index % 2 === 0 ? 'row-even' : 'row-odd'}>
                      <td style={{ textAlign: 'center', color: '#999' }}>{index + 1}</td>
                      <td>{task.specialty}</td>
                      <td className="cell-name">{task.text}</td>
                      <td style={{ textAlign: 'center' }}>{formatDate(task.dueDate)}</td>
                      <td style={{ textAlign: 'center' }}>
                        <span className="status-badge" style={{
                          background: task.dueDate && new Date(task.completedDate) > new Date(task.dueDate) ? '#fef2f2' : '#f0fdf4',
                          color: task.dueDate && new Date(task.completedDate) > new Date(task.dueDate) ? '#dc2626' : '#16a34a'
                        }}>{formatDate(new Date(task.completedDate))}</span>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <div style={{ display: 'flex', gap: '0.4rem', justifyContent: 'center' }}>
                          <button className="btn-action btn-restore" onClick={() => restoreCompletedTask(task.id)}>Devolver</button>
                          <button className="btn-action btn-delete" onClick={() => deleteCompletedTask(task.id)}>Eliminar</button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Stats cards Materiales */}
        <div className="progress-cards-row" style={{ gridTemplateColumns: 'repeat(2, 1fr)', padding: '20px 24px 0' }}>
          <div className="progress-stat-card">
            <div className="progress-stat-icon" style={{ background: '#f9fafb', color: '#374151' }}>■</div>
            <div className="progress-stat-info">
              <span className="progress-stat-label">Total Materiales Activos</span>
              <span className="progress-stat-number">{materiales.length}</span>
            </div>
          </div>
          <div className="progress-stat-card">
            <div className="progress-stat-icon" style={{ background: '#f0fdf4', color: '#16a34a' }}>✓</div>
            <div className="progress-stat-info">
              <span className="progress-stat-label">Materiales Completados</span>
              <span className="progress-stat-number" style={{ color: '#16a34a' }}>{completedMateriales.length}</span>
            </div>
          </div>
        </div>

        {/* Tabla Materiales Completados */}
        <div className="progress-table-section" style={{ marginTop: '2rem' }}>
          <div className="critical-title-row">
            <span className="critical-square" style={{ color: '#374151' }}>■</span>
            <span className="critical-title-text">Materiales Completados</span>
            <span className="critical-count-badge" style={{ background: '#f9fafb', color: '#374151' }}>{completedMateriales.length}</span>
          </div>

          <div className="table-wrapper">
            <table className="critical-table-email">
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>#</th>
                  <th>Material</th>
                  <th>Espec.</th>
                  <th style={{ textAlign: 'center' }}>Inicio de Partida</th>
                  <th style={{ textAlign: 'center' }}>Fecha Completada</th>
                  <th style={{ textAlign: 'center' }}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {completedMateriales.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: '#999' }}>No hay materiales completados</td>
                  </tr>
                ) : (
                  completedMateriales.map((material, index) => (
                    <tr key={material.id} className={index % 2 === 0 ? 'row-even' : 'row-odd'}>
                      <td style={{ textAlign: 'center', color: '#999' }}>{index + 1}</td>
                      <td className="cell-name">{material.text}</td>
                      <td>{material.specialty || '-'}</td>
                      <td style={{ textAlign: 'center' }}>{formatDate(material.dueDate)}</td>
                      <td style={{ textAlign: 'center' }}>
                        <span className="status-badge" style={{
                          background: material.dueDate && new Date(material.completedAt) > new Date(material.dueDate) ? '#fef2f2' : '#f0fdf4',
                          color: material.dueDate && new Date(material.completedAt) > new Date(material.dueDate) ? '#dc2626' : '#16a34a'
                        }}>{formatDate(new Date(material.completedAt))}</span>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <div style={{ display: 'flex', gap: '0.4rem', justifyContent: 'center' }}>
                          <button 
                            className="btn-action btn-restore" 
                            onClick={() => restoreCompletedMaterial(material.id)}
                          >
                            Devolver
                          </button>
                          <button 
                            className="btn-action btn-delete" 
                            onClick={() => handleDeleteCompletedMaterial(material.id)}
                          >
                            Eliminar
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TabProgreso;
